import React, { PureComponent, useEffect } from 'react';
import { connect } from 'react-redux';
import Axios from 'axios';
import { ApiConstant } from '../../../../constants';
import PropTypes from 'prop-types';
import { Spin, Tag } from 'antd';
import roundCheck from '../../../../assets/img/round-check_circle-24px.svg';
import './InStackDemandSelector.css';
import InStackDemandSelectorActions from './InStackDemandSelector.actions';
import { uniq } from 'lodash';
class InStackDemandSelector extends PureComponent {
  state = {
    loading: false,
    demandList: [],
    skills: []
  };

  componentDidMount () {
    this.initialize();
  }

  initialize = () => {
    this.setState({ loading: true });
    Axios.post(`${ApiConstant.BASE_URL}common-user/`, { action: 'GET_STACK_DEMAND_DEV' })
      .then(response => response.data)
      .then(({ success, result }) => {
        if (success) {
          const [demandList, skills, stackDemandDev] = result;
          const filterDemandList = demandList.filter(demandStackItem => !demandStackItem.is_hidden);
          this.setState({ demandList: filterDemandList.map(this.initInStackDemandItem(skills, stackDemandDev)), skills, stackDemandDev });
        }
      })
      .then(this.saveRedux)
      .catch(console.error)
      .finally(() => this.setState({ loading: false }));
  }

  initInStackDemandItem = (skills, stackDemandDevList) => item => {
    const initSkill = skill => {
      skill.isInStackDemandDev = stackDemandDevList.find(elm => elm.skill_id === skill.skill_id && elm.stack_demand_id === item.stack_demand_id);
      if (skill.require) {
        skill.checked = true;
      } else if (skill.isInStackDemandDev) {
        skill.checked = true;
      }
      skill.set = (obj = {}) => {
        if (skill.require) {
          obj.checked = true;
        }
        Object.assign(skill, obj);
        item.set();
      };
      return skill;
    };

    item.skills = skills.filter(skill => skill.stack_demand_id === item.stack_demand_id).map(initSkill);

    item.nbr_require = Math.max(item.pass_require - item.skills.filter(skill => skill.require).length, 0);

    item.set = (obj = {}) => {
      Object.assign(item, obj);
      this.setState({ demandList: [...this.state.demandList] });
    };

    item.onChange = checked => {
      if (checked) {
        item.open();
      } else {
        item.skills.forEach(skill => skill.set({ checked }));
        item.set({ checked, popupVisible: false, stackDemandDev: [] });
        item.save();
      }
    };

    item.open = () => {
      if (item.skills.length && item.skills.some(skill => !skill.require)) {
        item.set({ popupVisible: true });
      } else {
        item.close();
      }
    };

    item.checked = item.skills.filter(skill => skill.isInStackDemandDev).length >= item.pass_require;

    item.close = () => {
      let checked;
      let stackDemandDev = [];

      if (item.skills.filter(skill => skill.require || skill.checked).length >= item.pass_require) {
        checked = true;
        const requireList = item.skills.filter(skill => skill.require);
        const additionalList = item.skills.filter(skill => !skill.require && skill.checked);

        if (additionalList.length) {
          /* IF THERE IS ADDITIONAL SKILL LIST */
          stackDemandDev = additionalList.map((skill, group) => {
            return [skill, ...requireList].map(({ skill_id }) => ({ stack_demand_id: item.stack_demand_id, group: group + 1, skill_id }));
          }).reduce((acc, arr) => [...acc, ...arr], []);
        } else {
          /* IF ALL REQUIRED, NO ADDITINOAL LIST, GROUP = 1 */
          stackDemandDev = requireList.map(skill => {
            return [skill].map(({ skill_id }) => ({ stack_demand_id: item.stack_demand_id, group: 1, skill_id }));
          }).reduce((acc, arr) => [...acc, ...arr], []);
        }
      } else {
        checked = !item.skills.length;
      }
      item.set({ checked, popupVisible: false, stackDemandDev });
      item.save();
    };

    item.save = () => {
      item.set({ loading: true });
      return Axios.post(`${ApiConstant.BASE_URL}common-user/`, { action: 'SAVE_STACK_DEMAND_DEV', stackDemandDev: item.stackDemandDev, stack_demand_id: item.stack_demand_id })
        .then(response => response.data)
        .then(({ roleChangeDetected }) => {
          if (roleChangeDetected && this.props.roleChangeDetected) {
            this.props.roleChangeDetected(true);
          }
        })
        .then(this.saveRedux)
        .catch(console.error)
        .finally(() => item.set({ loading: false }));
    };

    return item;
  }

  saveRedux = () => {
    const { demandList } = this.state;
    const otherStackDemandId = this.props.user_demand_stack_skills.otherStackDemandId;
    const otherStackSkillsIds = this.props.user_demand_stack_skills.otherStackSkillsIds;
    let skillsIds = [];
    let stackDemandIds = demandList.filter(item => item.checked).map(item => {
      item.skills.filter(skill => skill.require || skill.checked).map(skill => {
        if (!skillsIds.includes(skill.skill_id)) {
          skillsIds.push(skill.skill_id);
        }
      });
      return item.stack_demand_id;
    });

    if (otherStackDemandId) {
      stackDemandIds.push(otherStackDemandId);
      stackDemandIds = uniq(stackDemandIds);
    }

    if (Array.isArray(otherStackSkillsIds)) {
      skillsIds.push(...otherStackSkillsIds);
      skillsIds = uniq(skillsIds);
    }

    this.props.dispatch({ type: InStackDemandSelectorActions.SET_SELECTED_SKILLS, payload: { skillsIds, stackDemandIds, otherStackSkillsIds, otherStackDemandId } });
    if (this.props.onChange) this.props.onChange(null, { skillsIds });
  }

  render () {
    const { demandList } = this.state;
    return (
      <div className="InStackDemandSelector">
        {demandList.map(item => <InStackDemandItem key={item.stack_demand_id} item={item} />)}
      </div>
    );
  }
}

const InStackDemandItem = ({ item }) => {
  useEffect(() => {
    const handlerClick = (e) => {
      const path = e.path || (e.composedPath && e.composedPath());
      if (path && !path.find(elm => elm.classList && elm.classList.contains('InStackDemandItemPopupList'))) {
        item.close();
      } else {
        console.error('Browser not supported path/composedPath, IE?');
      }
    };
    if (item.popupVisible) {
      document.addEventListener('click', handlerClick, false);
    }
    return () => {
      document.removeEventListener('click', handlerClick, false);
    };
  }, [item.popupVisible]);
  return (
    <Spin spinning={!!item.loading}>
      <Tag.CheckableTag className="InStackDemandItem" checked={!!item.checked} onChange={item.onChange} onClick={e => e.stopPropagation()}>
        <span>{ item.stack_demand_name }</span>
        {/* {item.no_of_jobs ? <span className="njobs">{ item.no_of_jobs > 1 ? item.no_of_jobs + ' jobs' : item.no_of_jobs + ' job' }</span> : null} */}
        {item.popupVisible
          ? (
            <div className="InStackDemandItemPopupList" onClick={e => e.stopPropagation()}>
              <div className="InStackDemandItemPopupList-title"><span>SELECT ADDITIONAL SKILLS</span><span>Require at least { item.nbr_require > 0 ? item.nbr_require : '' }</span></div>
              { item.skills.filter(skill => !skill.require).map(skill => <SkillItem key={skill.skill_id} skill={skill} />) }
            </div>
          )
          : null}
      </Tag.CheckableTag>
    </Spin>
  );
};

const SkillItem = ({ skill }) => {
  return (
    <div className={`InStackDemandItemSkillItem ${skill.checked ? 'checked' : ''}`} onClick={e => skill.set({ checked: !skill.checked })}>
      <img
        src={roundCheck}
        style={{
          width: 18,
          height: 18,
          background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
          opacity: 1
        }}
        alt="check"
      />
      <span>{ skill.skill_name }</span>
    </div>
  );
};

InStackDemandSelector.propTypes = {
  dispatch: PropTypes.func,
  onChange: PropTypes.func,
  roleChangeDetected: PropTypes.func,
  user_demand_stack_skills: PropTypes.object
};

InStackDemandItem.propTypes = {
  item: PropTypes.object
};

SkillItem.propTypes = {
  skill: PropTypes.object
};

const mapStateToProps = appState => ({
  store: appState,
  user_demand_stack_skills: appState.user_demand_stack_skills
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(InStackDemandSelector);
